import React, { useMemo } from "react";
import styled from "@emotion/styled";
import { useIntl } from "react-intl";

import Paper from "@mui/material/Paper";
import Checkbox from "components/Checkbox";
import ParkkiTheme from "themes/ParkkiTheme";

const Container = styled(Paper)`
  display: flex;
  flex-direction: column;
  padding-left: 11px;
  margin-top: 10px;
`;

type Props = {
  options: {
    [key: string]: { display: boolean; onChange: Function; value: boolean };
  };
  disabled?: boolean;
};

function MapCheckboxContainer({ options, disabled }: Props): JSX.Element {
  const { formatMessage } = useIntl();

  const formattedOptions = useMemo(() => {
    return Object.keys(options).map((key) => {
      return { ...options?.[key], labelKey: key };
    });
  }, [options]);

  return (
    <Container>
      {formattedOptions.map((option) => {
        if (!option?.display) {
          return null;
        }

        return (
          <Checkbox
            key={option?.labelKey}
            label={formatMessage({
              id: `components.mapCheckboxContainer.${option?.labelKey}`,
            })}
            labelColor={ParkkiTheme.colors.turquoise}
            checked={option?.value}
            onChange={(e, value) => {
              option?.onChange(value);
            }}
            disabled={disabled}
          />
        );
      })}
    </Container>
  );
}

MapCheckboxContainer.defaultProps = {
  disabled: false,
};

export default MapCheckboxContainer;
